document.addEventListener("DOMContentLoaded", () => {
  $(document).on('submit', '#ajax-form', function (e) {
    const dom = $(this)
    var method = ""
    if ($(this).attr("method") == "GET") {
      method = "GET"
    } else {
      method = ($("input[name='_method']").val() == 'patch' ? "patch" : "post");
    }
    
    dom.find('button[type="submit"]').attr('disabled', 'disabled')
    dom.find("input[type='submit']").attr('disabled', 'disabled')

    e.preventDefault()
    
    $.ajax({
      url: dom.attr('action'),
      method: method,
      headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
      data: dom.serialize(),
      dataType: "json",
      success: function (data) {
        hideModal()
        if (data.redirect_url != undefined && data.redirect_url != ""){
          loadPage(data.redirect_url)
        }
        if (data.message != undefined){
          showToast('success', '', data.message)
        }
      },
      error: function (jqXHR) {
        console.log("gagal")
        showToast('error', '', jqXHR.responseJSON.message)
        dom.find('input[type="submit"]').removeAttr('disabled')
        dom.find('button[type="submit"]').removeAttr('disabled')
      },
      complete: function (res) {
        // console.log(res)
      }
    })
  })
})

$(document).on("click", ".sideways_check", function(){
  if ($(this).attr("check") == undefined) {
    $(this).attr("check", "0")
  }

  if ($(this).attr("check") == "0") {
    $(this).closest('tr').find("input[type='checkbox']").prop("checked", "checked")
    $(this).attr("check", "1")
  } else {
    $(this).closest('tr').find("input[type='checkbox']").prop("checked", false)
    $(this).attr("check", "0")
  }
})